var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4848",
    fillRule: "evenodd",
    d: "M0 0H1.4H2.54546V1.39814H1.4V2.54546H0V1.39814V0ZM3.81818 0H6.36364V1.39814H3.81818V0ZM1.4 3.81818H0V6.36364H1.4V3.81818ZM1.4 7.63636H0V10.1818H1.4V7.63636ZM12.6 3.81818H14V6.36364H12.6V3.81818ZM14 7.63636H12.6V10.1818H14V7.63636ZM7.63636 0H10.1818V1.39814H7.63636V0ZM6.36364 12.6H3.81818V14H6.36364V12.6ZM7.63636 12.6H10.1818V14H7.63636V12.6ZM0 14H1.4H2.54546V12.6H1.4V11.4546H0V12.6V14ZM12.6 0H14V1.39814V2.54546H12.6V1.39814H11.4546V0H12.6ZM14 14H12.6H11.4546V12.6H12.6V11.4546H14V12.6V14Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.b23b4ecf1b7aaa38e25f244c80446733.svg";
export { ForwardRef as ReactComponent };